import React from 'react';

const ResultsPhase = ({score, terms, masteryAnswers}) => {
  const percentage = score.total > 0 ? Math.round((score.correct / score.total) * 100) : 0;

  return (
    <div className="lcv-results-panel">
      <div className="lcv-results-score">{percentage}%</div>
      <div className="lcv-results-label">
        {score.passed ? 'Mastery Achieved!' : 'Keep Practicing!'}
      </div>
      <div className="lcv-results-detail">
        You got {score.correct} out of {score.total} questions correct.
        {score.passed
          ? ' Great work — you\'ve demonstrated mastery of this lesson!'
          : ` You need ${Math.round(score.threshold * 100)}% to pass. Review the terms below and try again.`}
      </div>

      <div className="lcv-results-breakdown">
        {terms.map((t, i) => {
          const answer = masteryAnswers.find(a => a.questionIndex === i);
          const passed = answer?.correct ?? false;
          return (
            <div key={i} className="lcv-result-row">
              <span className={`lcv-result-icon ${passed ? 'lcv-ri-pass' : 'lcv-ri-miss'}`}>
                {passed ? '✓' : '✗'}
              </span>
              <span className="lcv-result-term">{t.term}</span>
              <span className={`lcv-result-status ${passed ? 'lcv-rs-pass' : 'lcv-rs-miss'}`}>
                {passed ? 'Passed' : 'Review'}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResultsPhase;
